import { render, staticRenderFns } from "./ReadOnlyComponent.vue?vue&type=template&id=d5526b9a&"
import script from "./ReadOnlyComponent.vue?vue&type=script&lang=ts&"
export * from "./ReadOnlyComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5526b9a')) {
      api.createRecord('d5526b9a', component.options)
    } else {
      api.reload('d5526b9a', component.options)
    }
    module.hot.accept("./ReadOnlyComponent.vue?vue&type=template&id=d5526b9a&", function () {
      api.rerender('d5526b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/Elements/ReadOnlyComponent.vue"
export default component.exports